import * as Localization from 'expo-localization';
import countries from 'i18n-iso-countries/index';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '@/locales/en/common.json';
import enErrors from '@/locales/en/errors.json';
import esCommon from '@/locales/es/common.json';
import esErrors from '@/locales/es/errors.json';
import frCommon from '@/locales/fr/common.json';
import frErrors from '@/locales/fr/errors.json';

import { storage, storageKeys } from './storage';

// Get saved language or fall back to device language
const getSavedLanguage = (): string => {
  try {
    const saved = storage.getString(storageKeys.userLanguage);
    if (saved && ['en', 'es', 'fr'].includes(saved)) {
      return saved;
    }
  } catch {
    // Storage might not be available during test initialization
    // Fall through to device language
  }
  return Localization.getLocales()?.[0]?.languageCode || 'en';
};

i18n.use(initReactI18next).init({
  debug: false,
  load: 'languageOnly',
  ns: ['common', 'errors'],
  resources: {
    en: { common: enCommon, errors: enErrors },
    es: { common: esCommon, errors: esErrors },
    fr: { common: frCommon, errors: frErrors },
  },
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  supportedLngs: ['en', 'es', 'fr'],
  interpolation: {
    escapeValue: false,
  },
});

// Save language preference whenever it changes
i18n.on('languageChanged', (lng: string) => {
  storage.set(storageKeys.userLanguage, lng);
});

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/es.json'));
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'));

export default i18n;
